import { Tag } from 'antd';
import styled from 'styled-components';

import { lightAiPurple, aiPurple } from '../constants/colors';

export const SinapseTag = styled(Tag)`
  && {
    display: inline-flex;
    align-items: center;
    font-size: 14px;
    height: 24px;
    margin: 4px;
    background: ${lightAiPurple};
    border: 1px solid ${aiPurple};
    color: ${aiPurple};

    .anticon-close {
      margin-left: 4px;
    }

    .anticon-plus {
      margin-left: 4px;
    }
  }
`;
